export const AUTH_QR_SOFT_TIMEOUT_MS = 5_000;
export const AUTH_QR_HARD_TIMEOUT_MS = 15_000;

export type AuthQrWatchdogStage = 'none' | 'soft' | 'hard';

export function getAuthQrWatchdogReport({
  authState,
  hasAuthQrToken,
  isQrMounted,
  elapsedMs,
  reportedStage,
}: {
  authState: string | undefined;
  hasAuthQrToken: boolean;
  isQrMounted: boolean;
  elapsedMs: number;
  reportedStage: AuthQrWatchdogStage;
}) {
  if (authState !== 'authorizationStateWaitQrCode' || isQrMounted) {
    return undefined;
  }

  if (elapsedMs >= AUTH_QR_HARD_TIMEOUT_MS && reportedStage !== 'hard') {
    return {
      stage: 'hard' as const,
      elapsedMs,
      authState,
      hasAuthQrToken,
      isQrMounted,
    };
  }

  if (elapsedMs >= AUTH_QR_SOFT_TIMEOUT_MS && reportedStage === 'none') {
    return {
      stage: 'soft' as const,
      elapsedMs,
      authState,
      hasAuthQrToken,
      isQrMounted,
    };
  }

  return undefined;
}
